(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aanbevolen-producten"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeBlock = (root) => {
      if (!root || root.dataset.stlInitialized === 'true') return;
      root.dataset.stlInitialized = 'true';

      root.querySelectorAll('[data-stl-card]').forEach((card) => {
        const variantsNode = card.querySelector('[data-stl-variants]');
        const selectors = Array.from(card.querySelectorAll('[data-stl-option]'));
        const price = card.querySelector('[data-stl-price]');
        const button = card.querySelector('[data-stl-add]');
        const buttonLabel = card.querySelector('[data-stl-button-label]');
        const image = card.querySelector('.stl-card__image');
        const message = card.querySelector('[data-stl-message]');
        const links = card.querySelectorAll('[data-stl-product-link], [data-stl-title-link]');

        if (!variantsNode || !button || !buttonLabel) return;

        let variants = [];

        try {
          variants = JSON.parse(variantsNode.textContent);
        } catch (error) {
          button.disabled = true;
          buttonLabel.textContent = 'Niet beschikbaar';
          return;
        }

        const updateCard = () => {
   const selectedOptions = selectors.map((selector) => selector.value);

const selectedVariant = selectors.length === 0
  ? variants.find(
      (variant) => String(variant.id) === String(button.dataset.variantId)
    ) || variants[0]
  : variants.find((variant) => {
      return variant.options.every(
        (option, index) => option === selectedOptions[index]
      );
    });

          message.textContent = '';
          message.classList.remove('is-error');

          if (!selectedVariant) {
            button.dataset.variantId = '';
            button.disabled = true;
            buttonLabel.textContent = 'Niet beschikbaar';
            return;
          }

          button.dataset.variantId = String(selectedVariant.id);
          button.disabled = !selectedVariant.available;
          buttonLabel.textContent = selectedVariant.available
            ? button.dataset.defaultLabel
            : 'Uitverkocht';

          if (price) price.textContent = selectedVariant.price;

          links.forEach((link) => {
            link.href = selectedVariant.url;
          });

          if (image && selectedVariant.image) {
            image.style.opacity = '0.35';
            image.removeAttribute('srcset');
            image.src = selectedVariant.image;
            image.alt = selectedVariant.image_alt || '';
            image.addEventListener('load', () => {
              image.style.opacity = '1';
            }, { once: true });
          }
        };

        selectors.forEach((selector) => {
          selector.addEventListener('change', updateCard);
        });

        button.addEventListener('click', async () => {
          const variantId = Number(button.dataset.variantId);
          if (!variantId || button.disabled) return;

          const defaultLabel = button.dataset.defaultLabel;
          button.disabled = true;
          button.classList.add('is-loading');
          buttonLabel.textContent = 'Toevoegen…';
          message.textContent = '';
          message.classList.remove('is-error');

          try {
            const rootUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            });

            const result = await response.json();

            if (!response.ok) {
              throw new Error(result.description || result.message || 'Toevoegen is niet gelukt.');
            }

            buttonLabel.textContent = 'Toegevoegd ✓';
            message.textContent = 'Product staat in je winkelwagen.';

            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { source: 'shop-the-look', response: result }
            }));

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

            setTimeout(() => {
              buttonLabel.textContent = defaultLabel;
              button.disabled = false;
            }, 1800);
          } catch (error) {
            message.textContent = error.message || 'Toevoegen is niet gelukt.';
            message.classList.add('is-error');
            buttonLabel.textContent = defaultLabel;
            button.disabled = false;
          } finally {
            button.classList.remove('is-loading');
          }
        });

        updateCard();
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-shop-the-look]').forEach(initializeBlock);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_865c782"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeBlock = (root) => {
      if (!root || root.dataset.stlInitialized === 'true') return;
      root.dataset.stlInitialized = 'true';

      root.querySelectorAll('[data-stl-card]').forEach((card) => {
        const variantsNode = card.querySelector('[data-stl-variants]');
        const selectors = Array.from(card.querySelectorAll('[data-stl-option]'));
        const price = card.querySelector('[data-stl-price]');
        const button = card.querySelector('[data-stl-add]');
        const buttonLabel = card.querySelector('[data-stl-button-label]');
        const image = card.querySelector('.stl-card__image');
        const message = card.querySelector('[data-stl-message]');
        const links = card.querySelectorAll('[data-stl-product-link], [data-stl-title-link]');

        if (!variantsNode || !button || !buttonLabel) return;

        let variants = [];

        try {
          variants = JSON.parse(variantsNode.textContent);
        } catch (error) {
          button.disabled = true;
          buttonLabel.textContent = 'Niet beschikbaar';
          return;
        }

        const updateCard = () => {
   const selectedOptions = selectors.map((selector) => selector.value);

const selectedVariant = selectors.length === 0
  ? variants.find(
      (variant) => String(variant.id) === String(button.dataset.variantId)
    ) || variants[0]
  : variants.find((variant) => {
      return variant.options.every(
        (option, index) => option === selectedOptions[index]
      );
    });

          message.textContent = '';
          message.classList.remove('is-error');

          if (!selectedVariant) {
            button.dataset.variantId = '';
            button.disabled = true;
            buttonLabel.textContent = 'Niet beschikbaar';
            return;
          }

          button.dataset.variantId = String(selectedVariant.id);
          button.disabled = !selectedVariant.available;
          buttonLabel.textContent = selectedVariant.available
            ? button.dataset.defaultLabel
            : 'Uitverkocht';

          if (price) price.textContent = selectedVariant.price;

          links.forEach((link) => {
            link.href = selectedVariant.url;
          });

          if (image && selectedVariant.image) {
            image.style.opacity = '0.35';
            image.removeAttribute('srcset');
            image.src = selectedVariant.image;
            image.alt = selectedVariant.image_alt || '';
            image.addEventListener('load', () => {
              image.style.opacity = '1';
            }, { once: true });
          }
        };

        selectors.forEach((selector) => {
          selector.addEventListener('change', updateCard);
        });

        button.addEventListener('click', async () => {
          const variantId = Number(button.dataset.variantId);
          if (!variantId || button.disabled) return;

          const defaultLabel = button.dataset.defaultLabel;
          button.disabled = true;
          button.classList.add('is-loading');
          buttonLabel.textContent = 'Toevoegen…';
          message.textContent = '';
          message.classList.remove('is-error');

          try {
            const rootUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            });

            const result = await response.json();

            if (!response.ok) {
              throw new Error(result.description || result.message || 'Toevoegen is niet gelukt.');
            }

            buttonLabel.textContent = 'Toegevoegd ✓';
            message.textContent = 'Product staat in je winkelwagen.';

            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { source: 'shop-the-look', response: result }
            }));

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

            setTimeout(() => {
              buttonLabel.textContent = defaultLabel;
              button.disabled = false;
            }, 1800);
          } catch (error) {
            message.textContent = error.message || 'Toevoegen is niet gelukt.';
            message.classList.add('is-error');
            buttonLabel.textContent = defaultLabel;
            button.disabled = false;
          } finally {
            button.classList.remove('is-loading');
          }
        });

        updateCard();
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-shop-the-look]').forEach(initializeBlock);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
